module.exports = __webpack_public_path__ + "static/media/tuesday-camps.74c0ca44.jpeg";